import { BUY_LABEL_SUCCESS, BUY_LABEL_REQUEST, BUY_LABEL_FAILURE } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const buyLabelReducer = (state = initialState, action) => {
    switch (action.type) {
        case BUY_LABEL_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case BUY_LABEL_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case BUY_LABEL_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default buyLabelReducer;
